// pages
import Search from "pages/Search";
import Features from "pages/Statistics/Graphics/Features";
import CommercialValue from "pages/Statistics/Graphics/CommercialValue";
import EconomicActivity from "pages/Statistics/Graphics/EconomicActivity";
import Projects from "pages/Documentation/forms/Projects";
import Calification from "pages/Documentation/forms/Calification";
import Construction from "pages/Documentation/forms/Construction";
import LevelConstruction from "pages/Documentation/forms/LevelConstruction";
import Law from "pages/Documentation/culture/Law";
import SpecialLaw from "pages/Documentation/culture/SpecialLaw";
import PropertyProtection from "pages/Documentation/culture/PropertyProtection";
import OrganizationalChart from "pages/Documentation/culture/OrganizationalChart";
import RegulationLaw from "pages/Documentation/culture/RegulationLaw";
import ServiceFees from "pages/Documentation/culture/ServiceFees";
import ProjectAuthorization from "pages/Documentation/culture/ProjectAuthorization";
import Intervention from "pages/Documentation/guides/Intervention";
import InterventionProcess from "pages/Documentation/guides/InterventionProcess";
import BusinessCharacteristics from "pages/Vendors/BusinessCharacteristics";
import Sociodemographics from "pages/Vendors/Sociodemographics";
// import LifeSatisfaction from "pages/Vendors/LifeSatisfaction";
import PercivedProblems from "pages/Vendors/PercivedProblems";
// import BusinessOperation from "pages/Vendors/BusinessOperation";
import IncomeExpenses from "pages/Vendors/IncomeExpenses";
import Georeference from "pages/Vendors/Georeference";
import SociodemographicCharacteristics from "pages/Clients/SociodemographicCharacteristics";
import Preferences from "pages/Clients/Preferences";
import Source from "pages/Clients/Source";
import Income from "pages/Clients/Income";
import AboutUs from "pages/Home/sections/AboutUs";
import UserGuide from "pages/NavigationHelp/userGuide";
import ResultsCHM from "pages/Documentation/results/ResultsCHM";
import ResultsCVVP from "pages/Documentation/results/ResultsCVVP";

const routes = [
  {
    name: "Bienes Inmuebles",
    // icon: <span className="material-icons-outlined">search</span>,
    dropdown: true,
    collapse: [
      {
        name: "Buscador de Inmuebles",
        route: "/search",
        href: "/search",
        component: <Search />,
      },
      {
        name: "Características de los Bienes Inmuebles",
        route: "/statistics/features",
        component: <Features />,
      },
      {
        name: "Precio de los Bienes Inmuebles",
        route: "/statistics/commercialvalue",
        component: <CommercialValue />,
      },
    ],
  },
  {
    name: "Actividades Económicas Urbanas",
    collapse: [
      {
        name: "Identificación",
        route: "/statistics/economicactivity",
        component: <EconomicActivity />,
      },
      {
        name: "Localización",
        href: "https://rpubs.com/VictorSandoval/910933",
      },
      {
        name: "Flujos vehiculares",
        href: "https://rpubs.com/VictorSandoval/910891",
      },
      {
        name: "Flujos peatonales",
        href: "https://rpubs.com/VictorSandoval/910896",
      },
    ],
  },
  {
    name: "Vendedores en la Vía Pública",
    columns: 1,
    rowsPerColumn: 3,
    collapse: [
      {
        name: "Vendedores",
        description: "Vendedores",
        dropdown: true,
        collapse: [
          {
            name: "Ubicación",
            route: "/vendors/georeference",
            component: <Georeference />,
          },
          {
            name: "Características sociodemográficas",
            route: "/vendors/sociodemographics",
            component: <Sociodemographics />,
          },
          {
            name: "Funcionamiento y características del negocio",
            route: "/vendors/businesscharacteristics",
            component: <BusinessCharacteristics />,
          },
          {
            name: "Ingresos y gastos",
            route: "/vendors/vendorsincome",
            component: <IncomeExpenses />,
          },
          {
            name: "Inconvenientes que encuentran los VVP",
            route: "/vendors/perceivedproblems",
            component: <PercivedProblems />,
          },
          /*
          {
            name: "Satisfacción de Vida",
            route: "/vendors/lifesatisfaction",
            component: <LifeSatisfaction />,
          },
          {
            name: "Operación del Negocio",
            route: "/vendors/businessoperation",
            component: <BusinessOperation />,
          },
          */
        ],
      },
      {
        name: "Clientes VVP",
        description: "Clientes VVP",
        dropdown: true,
        collapse: [
          {
            name: "Ubicación",
            route: "/clients/source",
            component: <Source />,
          },
          {
            name: "Características sociodemográficas",
            route: "/clients/sociodemographic",
            component: <SociodemographicCharacteristics />,
          },
          {
            name: "Preferencias y comportamientos de los clientes",
            route: "/clients/preferences",
            component: <Preferences />,
          },
          {
            name: "Ingresos de los clientes del Centro Histórico",
            route: "/clients/income",
            component: <Income />,
          },
        ],
      },
    ],
  },
  {
    name: "Normativa y Trámites",
    columns: 1,
    rowsPerColumn: 3,
    collapse: [
      {
        name: "Guías",
        description: "Ver guías",
        dropdown: true,
        collapse: [
          {
            name: "Intervención de inmuebles",
            route: "/documentation/guides/intervention",
            component: <Intervention />,
          },
          {
            name: "Procesos iIntervención de inmuebles",
            route: "/documentation/guides/interventionprocess",
            component: <InterventionProcess />,
          },
        ],
      },
      {
        name: "Formularios",
        description: "Ver formularios",
        dropdown: true,
        collapse: [
          {
            name: "Autorización de proyectos",
            route: "/documentation/forms/projects",
            component: <Projects />,
          },
          {
            name: "Calificación del lugar",
            route: "/documentation/forms/calification",
            component: <Calification />,
          },
          {
            name: "Línea y nivel de construcción",
            route: "/documentation/forms/levelconstruction",
            component: <LevelConstruction />,
          },
          {
            name: "Permiso de construcción",
            route: "/documentation/forms/construction",
            component: <Construction />,
          },
        ],
      },
      {
        name: "Documentos MICULTURA",
        description: "Ver Documentos Mi Cultura",
        dropdown: true,
        collapse: [
          {
            name: "Organigrama",
            route: "/documentation/culture/organizationalchart",
            component: <OrganizationalChart />,
          },
          {
            name: "Ley de cultura",
            route: "/documentation/culture/law",
            component: <Law />,
          },
          {
            name: "Ley especial de protección al patrimonio cultural de El Salvador",
            route: "/documentation/culture/speciallaw",
            component: <SpecialLaw />,
          },
          {
            name: "Tarifario de servicios",
            route: "/documentation/culture/servicefees",
            component: <ServiceFees />,
          },
          {
            name: "Trámites de autorización de proyectos",
            route: "/documentation/culture/projectauthorization",
            component: <ProjectAuthorization />,
          },
          {
            name: "Lineamientos de protección de Bienes Inmuebles",
            route: "/documentation/culture/propertyprotection",
            component: <PropertyProtection />,
          },
          {
            name: "Reglamento de la Ley Especial de protección al patrimonio cultural",
            route: "/documentation/culture/regulationlaw",
            component: <RegulationLaw />,
          },
        ],
      },
    ],
  },
  {
    name: "Acerca de",
    columns: 1,
    rowsPerColumn: 3,
    collapse: [
      {
        name: "Hallazgos más importantes",
        dropdown: true,
        collapse: [
          {
            name: "Resultados de Inteligencia de Negocios CHSM",
            route: "/resultschm",
            component: <ResultsCHM />,
          },
          {
            name: "Resultados VVP y CVVP",
            route: "/resultscvvp",
            component: <ResultsCVVP />,
          },
        ],
      },
      {
        name: "Nosotros",
        dropdown: true,
        collapse: [
          {
            name: "Acerca de Nosotros",
            route: "/aboutus",
            component: <AboutUs />,
          },
          {
            name: "Guía de uso del sitio",
            route: "/userguide",
            component: <UserGuide />,
          },
        ],
      },
    ],
  },
];

export default routes;
